import {MessageBox, Message} from 'element-ui'
import { showFullScreenLoading,  tryHideFullScreenLoading } from '@/utils/loading'
import axios from 'axios';
import musicManager from '@/utils/musicManager';

// 基本配置
export const instance = axios.create({
    baseURL: 'https://englishapi.jacknum1.top/', // 根据实际情况修改API地址
    // baseURL: 'http://192.168.0.130:8080/', // 根据实际情况修改API地址
    timeout: 600000 // 设置超时时间，单位为ms
});

// 请求拦截器
instance.interceptors.request.use(config => {
    config.headers['Authorization'] = localStorage.getItem('token'); // 设置请求头部分，这里举例使用了localStorage存储的token作为身份标识
    if (config.headers.isLoading !== false) {
        // 如果配置了isLoading: false，则不显示loading
        showFullScreenLoading()
    }
    return config;
}, error => {
    tryHideFullScreenLoading()
    Message.error({
        message: '请求超时，请稍后重试！'
    })
    return Promise.reject(error);
});

// 响应拦截器
instance.interceptors.response.use(response => {
    console.log(response.config.url,'响应')
    tryHideFullScreenLoading()
    const data = response.data;
    if (data && data.code !== 200) { // 根据接口返回的状态码判断是否有错误
        if(data.code === 401){
            // 登录过期时关闭背景音乐
            musicManager.logout();
            
            MessageBox.confirm('登录已过期，请重新登录', '提示', {
                confirmButtonText: '确定',
                showCancelButton: false,
                type: 'error'
            }).then(() => {
                window.location.href = '/'
            })
        }else{
            Message({
                message: data.msg,
                type: 'error',
            })
        }

        return Promise.reject(new Error(data.message));
    } else {
        return data;
    }
}, error => {
    tryHideFullScreenLoading()
    Message({
        message: '连接错误，请稍后重试！',
        type: 'error',
        duration: 5 * 1000
    })
    return Promise.reject(error);
});

